/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_S7_BodyInputs */

const en_fc_tut_s7_body = /** @type {(inputs: Fc_Tut_S7_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag any of 90+ effects or ~30 transitions from the Effects panel onto a clip or cut. In Effect Controls, click the stopwatch beside a property to start keyframing, move the playhead and change the value. Then open the velocity graph to ease the motion.`)
};

/**
* | output |
* | --- |
* | "Drag any of 90+ effects or ~30 transitions from the Effects panel onto a clip or cut. In Effect Controls, click the stopwatch beside a property to start keyf..." |
*
* @param {Fc_Tut_S7_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_s7_body = /** @type {((inputs?: Fc_Tut_S7_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_S7_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_s7_body(inputs)
});
export { fc_tut_s7_body as "fc.tut.s7.body" }